import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { SrdsHomeView } from '../components/views/srdsDashboardView'

export default function SrdsHome() {
    return (
        <div className="srdsHome">
            <Sidebar />
            <MainView><SrdsHomeView /></MainView>
        </div>
    )
}
